import React from "react";
import { TwitterTimelineEmbed } from "react-twitter-embed";
import PropTypes from "prop-types";

import FeedsSlider from "./FeedsSlider";

const TwitterFeeds = ({ t }) => {
  const feeds = ["EGWwritings", "ellenwhite"];

  const renderItem = ({ item }) => {
    return (
      <TwitterTimelineEmbed sourceType="profile" screenName={item} />
    );
  };

  return (
    <FeedsSlider renderItem={renderItem} records={feeds} containerClassName="twitter-feeds">
      <h3 className="feeds-header">
        {t("follow_us_on")}
        <a
          href="https://twitter.com/egwwritings?lang=en"
          rel="nofollow noopener noreferrer"
          target="_blank"
        >
          {"X (Twitter)"}
        </a>
      </h3>
    </FeedsSlider>
  );
};

TwitterFeeds.propTypes = {
  t: PropTypes.func.isRequired
};

export default TwitterFeeds;
